module.exports = __webpack_public_path__ + "static/media/menu-usuarios.9a8c7147.svg";